<template>
	<div class="column" :class="getClasses">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		cols: {
			type: String,
			default: '4'
		}
	},

	computed: {
		getClasses() {
			return {
				[`is-${this.cols}`]: true
			};
		}
	}
};
</script>
